// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import Vue from 'vue'
import VueMeta from 'vue-meta';
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import App from './App'
import axios from 'axios'
import qs from 'qs'
import router from './router'
import jQuery from 'jquery'
import VueSweetalert2 from 'vue-sweetalert2';
global.jQuery = jQuery
global.Token = ''
global.v3Token = ''
global.Code = ''
global.Imgurl="https://storage.cloud.google.com/committee_file/news/";
import VueLazyload from 'vue-lazyload'
import VueOffline from 'vue-offline'
import loadImgPath from './assets/loading-state-image.png'
import notfoundImgPath from './assets/cantdisplay-image.png'
// 暫時不做 ＬＩＮＥ 分享
// import VueSocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'
//let bootstrap = require('bootstrap')

import VueGtm from 'vue-gtm';

Vue.use(require('vue-script2'))

axios.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}

let GTMSetting = {
  id: 'GTM-K446H7G',
  enabled: true, 
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true,
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
}

if(process.env.NODE_ENV != "master"){
  GTMSetting.queryParams = {
    gtm_auth: '4KFf6LZSHibfYVJXAwtT-w',
    gtm_preview: 'env-59',
    gtm_cookies_win: 'x'
  }
}
// 暫時不做 ＬＩＮＥ 分享
// Vue.use(VueSocialSharing);
Vue.use(VueClipboard)
Vue.use(VueMeta, options);
Vue.use(VueOffline)
Vue.use(VueGtm, GTMSetting);
//Lazyload
// 盡量不要用 babel 過奇怪的路徑啦...
Vue.use(VueLazyload, {
  error: notfoundImgPath,
  loading: loadImgPath,
  try: 1 // 这个是加载图片数量
})

const options = {
	width: '90%',
	confirmButtonColor: 'transparent',
	cancelButtonColor: 'transparent'
}
Vue.use(VueSweetalert2, options); 

Vue.config.productionTip = false
// window.localStorage.setItem('token', encodeURIComponent("Rdu76ObLEv7h2PvWheejAM9flRB/OPhENecgJgNR19IXVpf4lQmX66c1TMD4PBWj5CB8ZeITQAGk2JBD89emrOAd6MwgWW+AogFeBdi52VtV3BnAm/ZDQdgmu6yg1YYrlUHIVpgxlWJFrGCs1eZLFQ3iKbGAEx71LnNWLlJW+Ss="))

router.beforeEach((to, from, next) => {

  setMetaTitle(to.meta.title)

  if(to.query.token != undefined){
    Token = v3url(to.fullPath, 'token') // to.fullPath.split('?token=')[1];
    Code = to.fullPath.split('&code=')[1];
    // ! 這裡要注意 v2 與 v3 的 token 差異 很嚴重喔 !!
    // ! v2 token 為維持 encodeURIComponent 狀態的 token 
    // ! v3 token 為 decodeURIComponent 的 token
    let v3Token = v3url(to.fullPath, 'token')
    global.v3Token = decodeURIComponent(v3Token)

    let v3AuthState = v3url(to.fullPath, 'appAuthLogin')
    localStorage.setItem('v3appAuthLogin', v3AuthState)

    localStorage.setItem('token', Token);                         // v2 版本用的 token
    localStorage.setItem('v3token', decodeURIComponent(v3Token)); // v3 版本用的 token
    localStorage.setItem('deviceCode', Code);
    localStorage.setItem('errMsgCheck', false); //防止彈窗重複出現
    next();
  }else{
    if(localStorage.getItem("token") != null){
      Token = localStorage.getItem("token");
    }
    localStorage.setItem('errMsgCheck', false); //防止彈窗重複出現
    next();
  }
  // console.log(to.name, window.location.href)
  // Vue.gtm.trackView(to.name, window.location.href);
  //alert('form:'+from.name+' to:'+to.name);
    if(from.name=='newsDetail' && to.name=='news'){
      if(window.localStorage.getItem('GotoNewsPage') != ''){
        document.location.href='#/news/?news_type='+window.localStorage.getItem('GotoNewsPage');
      }
    }else if(from.name=='FAQDetail' && to.name=='FAQList'){
      document.location.href='#/FAQList/?FAQ_type='+window.localStorage.getItem('GotoFAQPage');
    }else if(from.name=='newsDetail' && to.name=='myCollection'){
      document.location.href='#/myCollection/0'
    }else if(from.name=='FAQDetail' && to.name=='myCollection'){
      document.location.href='#/myCollection/1'
    }else if(from.name=='legalRuleDetail' && to.name=='myCollection'){
      document.location.href='#/myCollection/2'
    }
});

function v3url(url, key) {
  if (url.indexOf('?') !== -1) {
    let ary = url.split('?')[1].split('&')

    for (let i = 0; i <= ary.length - 1; i++) {
      if (ary[i].split('=')[0] === key) {
        return ary[i].split('=')[1]
      }
    }
  }
  return undefined
}

//針對ios特性 更改標題
function setMetaTitle(title) {
  document.title = title
  let mobile = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(mobile)) {
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    // 替换成站标favicon路径或者任意存在的较小的图片即可
    // iframe.setAttribute('src', 'static/img/blank.png')
    let iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', iframeCallback)
        document.body.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
  }
}

axios.interceptors.response.use(
response => {
  //console.log(response);
  jQuery('.overlayBG').remove()
  return response
}, error => {
  // console.log(error.response.config.url.split('/')[6])
  jQuery('.overlayBG').remove()
  let errMsgCheck = JSON.parse(localStorage.getItem("errMsgCheck"));
  if(router.history.current.name == 'v3newsDetail' || router.history.current.name == 'v3news' || router.history.current.name == 'v3search'){
    return Promise.reject(error.response)
  }
  if(router.history.current.name == 'municipalInfo' || router.history.current.name == 'municipalInfoDetail'){
    return Promise.resolve(error.response)
  }
  if(error.response && error.response.status == 401){
    //沒有Token
    if(!errMsgCheck){
      vm.alertDialog('未取得授權').then(()=>{
        localStorage.setItem('errMsgCheck', true)
        document.location.href='#/error'
        localStorage.removeItem("token");
      })
    }

  }else if(error.response && error.response.status == 400){
    switch (error.response.data.errorMessage.code) {
      case 3:
      //Token過期
        if(!errMsgCheck){
          vm.alertDialog('連線時間逾時 請重新載入')
          localStorage.setItem('errMsgCheck', true)
        }
        document.location.href='#/timeout'
        localStorage.removeItem("token");
        break;
      case 4:
      //未綁定社群
        if(!errMsgCheck){
          // let re=confirm("此功能限定會員使用，現在就加入會員吧！");
          // if(re){
          //   document.location.href='#/unbindSocial'
          // }
          vm.$swal({
            title: '系統提示',
            text: '此功能限定會員使用，現在就加入會員吧！',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: '加入會員',
            cancelButtonText: '暫時不用',
          }).then(res=>{
              if(res.value){
                document.location.href='#/unbindSocial'
              }
          })

          if(error.response.config.url.split('/')[6] == 'RecommendArticle' || error.response.config.url.split('/')[6] == 'AddToFavorites'){
          }else{
            localStorage.setItem('errMsgCheck', true)

          }
        }
        break;
      case 5:
      //非管委身份
        if(!errMsgCheck){
          vm.alertDialog('非管委身分')
          localStorage.setItem('errMsgCheck', true)
        }
        document.location.href='#/error'
        localStorage.removeItem("token");       
        break;                
    }
  }else{
    // vm.alertDialog('api發生錯誤')
  }
  return Promise.resolve(error.response)
})

//loading DIV show
axios.interceptors.request.use(config => {
  let active=config.url.split('/')[4];
  const municipalInfoActive = config.url.split('/')[config.url.split('/').length - 5]
  if(active == 'api' || active == 'RecommendArticle' || active=='AddToFavorites' || config.url.indexOf('GetRelatedCommitteeNews') != -1 || (municipalInfoActive === 'data.ntpc.gov.tw' && config.params.noLoading)){
    return config
  }else{
    jQuery('body').append(`
          <div class="overlayBG on">
              <div class="s-loading">
                  <div class="loader"></div>
              </div>
          </div>
    `)
    return config
  };
})

/* eslint-disable no-new */
global.vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data:{
    NewsTypeList:[],//新聞列表tag
    FAQTypeList:[]//問與答列表tag
  },
  methods: {
    //取得新聞標籤
    GetNewsType(functions){
      let vobj = this;
      vobj.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeNewsType`).then((response) => {
          if(response.status == 200){
            if(typeof(functions)=='function'){functions(response.data.data)};
            vobj.NewsTypeList=response.data.data
          }
      })
    },
    //回傳新聞中文名稱
    GetNewsTypeChn(news_type){
      let vobj = this;
      let flag = '';
      if(vobj.NewsTypeList.length == 0){
        this.GetNewsType(function(res){
          vobj.NewsTypeList=res
          next_tick();
        })
      }else{
        next_tick();
      }
      function next_tick(){
        vobj.NewsTypeList.map(tag => {
            if(tag.type_id == news_type){flag = tag.type_name}
        });
      }
      return flag;
    },
    //取得問與答標籤
    GetFAQType(functions){
      let vobj = this;
      vobj.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/getCommitteeQAType`).then((response) => {
          if(response.status == 200){
            if(typeof(functions)=='function'){functions(response.data.data)};
            vobj.FAQTypeList=response.data.data
          }
      })
    },
    //取得問與答中文名稱
    GetFAQTypeChn(FAQ_type){
      let vobj = this;
      let flag = '';
      if(vobj.FAQTypeList.length == 0){
        this.GetFAQType(function(res){
          vobj.FAQTypeList=res
          next_tick();
        })
      }else{
        next_tick();
      }
      function next_tick(){
        vobj.FAQTypeList.map(tag => {
            if(tag.type_id == FAQ_type){flag = tag.type_name}
        });
      }
      return flag;
    },
    //設定收藏 (type： 0文章 1問答 2法規)
    SetFavorites(type,id,status,func){
      let vobj = this;
      vobj.axios(`${process.env.ExternalApi}/api/ExternalControllers/Committee/AddToFavorites`,{
        method: 'post',
        data: {
          keepType:type,
          keepIndex:id,
          isCheck:status,
        },
        headers:{Authorization: Token}
      }).then((response) => {
          if(response.status == 200){
            func(response.data.data);
          }
      })
    },
    //設定推(type： 0文章 1問答 2法規)
    SetRecommend(type,id,status,func){
      let vobj = this;
      vobj.axios(`${process.env.ExternalApi}/api/ExternalControllers/Committee/RecommendArticle`,{
        method: 'post',
        data: {
          "pushType": type,
          "status": 1,
          "isCheck": status,
          "pushIndex": id
        },
        headers:{Authorization: Token}
      }).then((response) => {
          if(response.status == 200){
            func(response.data.data);
          }
      })
    },
    alertDialog(text){
			return new Promise((resolve, reject) => {
				this.$swal({
					// title: '系統訊息',
					text: text,
					allowOutsideClick: false,
					confirmButtonText:'確定',
				}).then(()=>{
					resolve()
				})
			})
		},
		alertDialogText(title, text, buttonText){  //自訂文字
			return new Promise((resolve, reject) => {
				this.$swal({
					title: title,
					text: text,
					allowOutsideClick: false,
					confirmButtonText: buttonText,
				}).then(()=>{
					resolve()
				})
			})
    },
    confirmDialog(confirmStr){
      return new Promise((resolve, reject) => {
        this.$swal({
          title: '系統提示',
          text: confirmStr,
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        }).then(res=>{
            if(res.value){
              resolve()
            }else{
              reject()
            }
        })
      })
    },
    dateFormat(date,format){ //回傳時間格式 format YYYY-MM-DD HH:mm:ss
      date = date.replace(/-/g,'/')
      let dateTime = new Date(date)
      let formatTime = format

      let year = `${dateTime.getFullYear()}`
      let month = (dateTime.getMonth()+1) < 10 ? `0${(dateTime.getMonth()+1)}` : `${(dateTime.getMonth()+1)}`
      let day = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : `${dateTime.getDate()}`
      let hour = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : `${dateTime.getHours()}`
      let minute = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : `${dateTime.getMinutes()}`
      let second = dateTime.getSeconds() < 10 ? `0${dateTime.getSeconds()}` : `${dateTime.getSeconds()}`
      formatTime = format.replace('YYYY', year).replace('MM', month).replace('DD', day).replace('HH', hour).replace('mm', minute).replace('ss', second)

      return formatTime
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js